import axiosInstance from './axiosInstance';

export const getAllCities = () => axiosInstance.get('/City/GetAll');

export const importCities = (rows) => axiosInstance.post('/City/Import', rows);
